/* eslint-disable @typescript-eslint/naming-convention */

// ---- 1. Real env vars ----
const { REACT_APP_ENV } = process.env;
const { REACT_APP_GATEWAY_URL } = process.env;
const { REACT_APP_KEYCLOAK_REALM } = process.env;
const { REACT_APP_KEYCLOAK_URL } = process.env;
const { REACT_APP_KEYCLOAK_CLIENT_ID } = process.env;
const { REACT_APP_SOCKET_URL } = process.env;

// ---- 2. Service groups + module paths ----
const SERVICE = {
  USER: 'services/user/api/v1',
  DATA: 'services/data/api/v1',
  APP: 'services/app/api/v1',
  COMMUNICATION: 'services/communication/api/v1',
};

const MODULE = {
  COMMUNICATION_MANAGEMENT: 'communication_management',
  UNIFIED_DATA_SOURCE: 'unified_data_source',
  USER_MANAGEMENT: 'user_management',
  ORGANIZATION: 'organization',
  ROLES_PERMISSIONS: 'roles_permissions',
  INPUT_SOURCE: 'input_source',
  NUDGE_MANAGEMENT: 'nudge_management',
  TARGET_MANAGEMENT: 'target_management',
};

const buildUrl = (service: string, moduleName: string): string =>
  `${REACT_APP_GATEWAY_URL}/${service}/${moduleName}`;

// ---- 3. Final URLs ----
const REACT_APP_API_URL: string = buildUrl(
  SERVICE.COMMUNICATION,
  MODULE.COMMUNICATION_MANAGEMENT
);
const REACT_APP_API_URL_UNIFIED: string = buildUrl(
  SERVICE.DATA,
  MODULE.UNIFIED_DATA_SOURCE
);
const REACT_APP_USER_API_URL: string = buildUrl(
  SERVICE.USER,
  MODULE.USER_MANAGEMENT
);
const REACT_APP_API_URL_ORG: string = buildUrl(
  SERVICE.USER,
  MODULE.ORGANIZATION
);
const REACT_APP_API_URL_ROLE: string = buildUrl(
  SERVICE.USER,
  MODULE.ROLES_PERMISSIONS
);
const REACT_APP_INPUT_SOURCE_API_URL: string = buildUrl(
  SERVICE.DATA,
  MODULE.INPUT_SOURCE
);
const REACT_APP_NUDGE_MANAGEMENT_API_URL: string = buildUrl(
  SERVICE.COMMUNICATION,
  MODULE.NUDGE_MANAGEMENT
);
const REACT_APP_API_URL_TARGET_MANAGEMENT: string = buildUrl(
  SERVICE.APP,
  MODULE.TARGET_MANAGEMENT
);

export {
  REACT_APP_ENV,
  REACT_APP_KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_CLIENT_ID,
  REACT_APP_API_URL,
  REACT_APP_API_URL_UNIFIED,
  REACT_APP_USER_API_URL,
  REACT_APP_API_URL_ORG,
  REACT_APP_API_URL_ROLE,
  REACT_APP_SOCKET_URL,
  REACT_APP_INPUT_SOURCE_API_URL,
  REACT_APP_NUDGE_MANAGEMENT_API_URL,
  REACT_APP_API_URL_TARGET_MANAGEMENT,
};
